(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const checkArrowes = document.getElementsByClassName("Collapsed_Title");
    for (const Collapsible__Arrow of checkArrowes) {
      Collapsible__Arrow.addEventListener(
        "click",
        function () {
          var arrow = this.getElementsByClassName("arrow")[0];
          if (!this.classList.contains("is-flipped")) {
            this.classList.add("is-flipped");
            this.getElementsByClassName("arrow")[0].classList.remove("up");
            this.getElementsByClassName("arrow")[0].classList.add("down");
            this.lastElementChild.style.display = "grid";
          } else {
            this.classList.remove("is-flipped");
            this.getElementsByClassName("arrow")[0].classList.remove("down");
            this.getElementsByClassName("arrow")[0].classList.add("up");
            this.lastElementChild.style.display = "none";
          }
        },
        false
      );
    }
  });
})();
/**
(function () {
  const modal = document.querySelector(".cust_modal");
  const overlay = document.querySelector(".cust_overlay");
  const openModalBtn = document.querySelector(".cust_btn-open");
  const closeModalBtn = document.querySelector(".cust_btn-close");
  const headerSticky = document.getElementsByClassName(
    "shopify-section shopify-section-group-header-group shopify-section--header"
  )[0];
  // close modal function
  const closeModal = function () {
    modal.classList.add("hidden");
    overlay.classList.add("hidden");
    headerSticky.classList.remove("no_z-index");
  };

  // close the modal when the close button and overlay is clicked
  closeModalBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

  // close modal when the Esc key is pressed
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });

  // open modal function
  const openModal = function () {
    modal.classList.remove("hidden");
    overlay.classList.remove("hidden");
    headerSticky.classList.add("no_z-index");
  };
  // open modal event
  if (openModalBtn) {
      openModalBtn.addEventListener("click", openModal);
  }
})();
**/
(function () {
  if (window.location.pathname.indexOf("/products/") !== -1) {
    var start_variant = document.getElementsByClassName(
      "ProductItem__Variant Variant-selected"
    )[0];
    var start_variant_id = start_variant.id;
    var box_variant_selected = document.getElementById(start_variant_id);

    // custom photo switcher show/hidden
    var product_photos = document.querySelectorAll(
      "div.product-gallery__media"
    );
    var selected_option_size = box_variant_selected.getAttribute(
      "variant-option-size"
    );
    var selected_option_color = box_variant_selected.getAttribute(
      "variant-option-color"
    );
    var selected_option_type = box_variant_selected.getAttribute(
      "variant-option-type"
    );

    product_photos.forEach((div) => {
      var media_option_size = div.getAttribute("media-option-size");
      var media_option_color = div.getAttribute("media-option-color");
      var media_option_type = div.getAttribute("media-option-type");
      if (
        (media_option_size == selected_option_size || !media_option_size) &&
        (media_option_color == selected_option_color || !media_option_color) &&
        (media_option_type == selected_option_type || !media_option_type)
      ) {
        //do something
        div.removeAttribute("hidden");
      } else {
        //do something
        div.setAttribute("hidden", "");
      }
    });

    document.addEventListener("variant:change", function (event) {
      let variant = event.detail.variant; // Gives you access to the whole variant details
      let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
      let product = event.detail.product; // Gives you access to the whole product that the variant belongs to
      let form = event.target; // The form that triggers the change
      var variant_id = variant.id;
      var box_variant_selected = document.getElementById(variant_id);

      // custom photo switcher show/hidden
      var product_photos = document.querySelectorAll(
        "div.product-gallery__media"
      );
      var selected_option_size = box_variant_selected.getAttribute(
        "variant-option-size"
      );
      var selected_option_color = box_variant_selected.getAttribute(
        "variant-option-color"
      );
      var selected_option_type = box_variant_selected.getAttribute(
        "variant-option-type"
      );

      product_photos.forEach((div) => {
        var media_option_size = div.getAttribute("media-option-size");
        var media_option_color = div.getAttribute("media-option-color");
        var media_option_type = div.getAttribute("media-option-type");
        if (
          (media_option_size == selected_option_size || !media_option_size) &&
          (media_option_color == selected_option_color ||
            !media_option_color) &&
          (media_option_type == selected_option_type || !media_option_type)
        ) {
          //do something
          div.removeAttribute("hidden");
        } else {
          //do something
          div.setAttribute("hidden", "");
        }
      });

      // custom variant sale select

      var box_product = box_variant_selected.parentElement;
      console.log(box_product);
      box_product.querySelectorAll("div.Variant-selected").forEach((div) => {
        div.classList.remove("Variant-selected");
        div.style.display = "none";
      });
      box_variant_selected.removeAttribute("style");
      return box_variant_selected.classList.add("Variant-selected");
    });
  } else {
    document.addEventListener("change", function (event) {
      let selected_swatch = event.target.value;
      let product_card = event.target.offsetParent;
      let box_product = product_card.lastElementChild;
      var box_variant_selected = "";

      box_product.querySelectorAll("div.Variant-selected").forEach((div) => {
        div.classList.remove("Variant-selected");
        div.style.display = "none";
      });
      var targeted_el = box_product.querySelectorAll(
        'div[variant-option-color="' + selected_swatch + '"]'
      )[0];
      targeted_el.removeAttribute("style");
      targeted_el.classList.add("Variant-selected");
    });
  }
})();

// DEACTIVATED THE VARIANT SCROLL on product page from "theme.js" row 3400

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.indexOf("/products/") !== -1) {
      var carousel = document.querySelector(".product-gallery__carousel");
      if (carousel.isScrollable) {
        carousel.select(0, { instant: true });
      }
      document.addEventListener('cart:refresh', function(event) {
        const cartDrawer = document.querySelector('cart-drawer'); 
        setTimeout(function(){
  cartDrawer.show();
}, 1000);
});
    }
  });
})();
